var _path, _rect, _rect2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkDecoration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 17,
    viewBox: "0 0 34 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2869 8.5L33.2869 8.5",
    stroke: "url(#paint0_linear_146_1567)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.3015,
    y: 8.3584,
    width: 5.57646,
    height: 5.57646,
    transform: "rotate(135 12.3015 8.3584)",
    fill: "#AC9FFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15.7869,
    y: 8.39355,
    width: 10.4559,
    height: 10.4559,
    transform: "rotate(135 15.7869 8.39355)",
    stroke: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_146_1567",
    x1: 14.7869,
    y1: 8.5,
    x2: 32.7869,
    y2: 8.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.198035,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkDecoration);
export default __webpack_public_path__ + "static/media/link-decoration.ddbc575ee7b2a0667886b22ac2e337ee.svg";
export { ForwardRef as ReactComponent };